export const typeStyles = `cursor-pointer w-1/2 text-center m-0 box-border font-nunitoMedium h-full py-2 px-0 text-sm`;
export const mainStyles = `relative border-t-4 bg-white shadow-cardShadow rounded w-full max-w-full box-border px-6 pt-[15px] pb-8 mt-8 mb-8 min-h-[150px] border-navy`;
export const cardTitleStyles = 'm-0 mr-2 p-0 text-base font-nunitoMedium inline-block';
export const wrapperStyles = 'w-full mr-[10px]';
export const labelStyles = 'text-xs leading-4 text-[#2b2b2b] tracking-[0.1px] uppercase m-0 font-nunitoBold mb-[8px]';
export const paragraphStyles = 'mb-1';
